import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.less']
})
export class LanguageSelectorComponent implements OnInit {
  public AvailableLanguages: Language[] = [
    { name: 'EN', code: 'en-US', icon: '/assets/img/en-flag.png' },
    { name: 'NL', code: 'nl-NL', icon: '/assets/img/nl-flag.png' }];

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  public SetLanguage(lang: Language): void {
    if (this.translate.currentLang !== lang.code) {
      this.translate.use(lang.code);
    }
  }

  public Selected(lang: Language): boolean {
    return lang.code === this.translate.currentLang;
  }
}

interface Language {
  name: string;
  code: string;
  icon: string;
}
